import { environmentConfig } from "@src/appV2/environment";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { get } from "@src/appV2/api";
import { z } from "zod";
import { isDefined } from "@clipboard-health/util-ts";

const agentInfoSchema = z.object({
  userId: z.string(),
  name: z.string(),
  email: z.string(),
  referralCode: z.string().optional(),
  referralCodeUsed: z
    .object({
      code: z.string(),
      createdAt: z.string(),
      referrer: z.string(),
    })
    .optional(),
  tmz: z.string().optional(),
});

type AgentInfo = z.infer<typeof agentInfoSchema>;

export function useGetAgentInfo(
  agentId?: string,
  options: UseQueryOptions<AgentInfo, unknown, AgentInfo> = {}
) {
  const url = `${environmentConfig.REACT_APP_API_MAIN_URL}/api/agentprofile/${agentId}/info`;
  return useQuery({
    queryKey: [url],
    queryFn: async () => {
      const response = await get({
        url,
        responseSchema: agentInfoSchema,
      });

      return response.data;
    },
    retry: 0,
    staleTime: 1000 * 60 * 5,
    refetchInterval: 1000 * 60 * 10,
    ...options,
    enabled: isDefined(agentId) && options.enabled,
  });
}
